import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import BannerForm from "./components/form";
import BannerTable from "./components/table";
import Service from "../../services/brandCategoryService";
import ProductService from "../../services/productService";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateBanner extends Component {
  state = {
    infoData: {},
    isEdit: true,
    productList: [],
  };

  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { bannerImageId } = params;
    this.setState({ loader: true, bannerImageId }, function () {
      this.callApiProductInfo();
    });
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { bannerImageId } = params;
    if (this.state.bannerImageId !== bannerImageId) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          bannerImageId: bannerImageId,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }

  callApiInfo = () => {
    const { bannerImageId, pageSize } = this.state;
    Service.fetchBannerImagesInfo(bannerImageId).then((response) => {
      if (!response.error) {
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.categoryList,
          imageUrl: response?.data?.imageUrl,
        });
      } else {
        this.setState({
          loader: false,
          infoData: {},
          imageUrl: undefined,
        });
      }
    });
    this.setState({ loader: false });
  };

  callApiProductInfo = () => {
    Service.fetchBrandCategoryInfo().then((response) => {
      // if (!response.error) {
      //   this.setState({ brandsList: response.brandList });
      //   this.setState({ categoryList: response.categoryList });
      // }
      if (!response.error) {
        this.setState(
          {
            modalFormShow: false,
            loader: false,
            productList: response?.data?.categoryList,
          },
          function () {
            this.callApiInfo();
          }
        );
      } else {
        this.setState({
          modalFormShow: false,
          loader: false,
          productList: [],
        });
      }
    });
    // ProductService.fetchProductList().then((response) => {
    //   if (!response.error) {
    //     this.setState({
    //       modalFormShow: false,
    //       productList: response.productList,
    //     });
    //     this.callApiInfo();
    //   } else {
    //     this.setState({
    //       modalFormShow: false,
    //       loader: false,
    //       productList: [],
    //     });
    //   }
    // });
    this.setState({ loader: false });
  };

  addBannerForm = (data) => {
    console.log("Data", { data })
    const { isEdit, info, bannerImageId, imageUrl, selectedProductId } = this.state;
    console.log("This State", this.state)
    this.setState({ loader: true });
    data["imageUrl"] = imageUrl;
    // data["bannerImageId"] = isEdit ? info._id : undefined;
    data["bannerImageId"] = isEdit ? bannerImageId : undefined;
    data["productId"] = selectedProductId;
    var method = isEdit ? "PUT" : "POST";
    Service.addBannerImageInfo(data, method).then((response) => {
      if (!response.error) {
        // this.callApiInfo();
        this.props.history.push("/banners/all");
      }
    });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  render() {
    const {
      bannerImageId,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
      productList,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;

    const bannerFormProps = {
      productList: productList,

      // onChangeProductId: this.onChangeProductId,
      onChangeProductId: (bannerImageId) => {
        this.setState({ selectedProductId: bannerImageId });
      },
      imageUrl: imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      info: infoData || {},
      active: this.state.active,
      onChangeProductUrl: (e) => {
        console.log({ e });
      },
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeBannerId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addBannerForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      // BannerForm: infoData,
    };
    return (
      <Fragment>
        <Breadcrumb title={"Update"} parent="Banner" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{ boxShadow: "1px 5px 24px 0 rgba(68, 102, 242, .05)", padding: "30px" }}>
                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}

                <BannerForm {...bannerFormProps} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateBanner;
